//import React from 'react';
import { Component as ReactComponent, createRef } from 'react';
import { PropTypes } from 'prop-types';
import { BaseFormComponent } from '../../shared/baseFormComponent';
import { ErrorsBlockComponent } from '../../shared/errorsBlockComponent';
import { ButtonBusyIndicatorComponent } from '../../shared/buttonBusyIndicatorComponent';
import { MakeApiCall, AssignProperties, HumanFileSize, FormatString, DisplaySuccessMessage, SetFocusOnFirstFormControl, PrepareError, CreateTimer, PreventDOMLock } from '../../shared/utils';

const CONTACTUS_ACTION = {
    NONE: 0,
    SEND: 1
}

import './styles.scss';

class FileItem extends ReactComponent {
    constructor(props, ...others) {
        super(props, ...others);
        this.handleDeleteClick = this.handleDeleteClick.bind(this);
    }

    handleDeleteClick() {
        const {file, onDelete} = this.props;

        PreventDOMLock(() => onDelete(file));
    }

    render() {
        const self = this;
        const {file, disabled} = self.props;

        return (
            <div className="attached-files__item">
                <div className="attached-files__item-name titleifoverflow">{file.name}</div>
                <div className="attached-files__item-size">({HumanFileSize(file.size)})</div>
                <div className="attached-files__item-delete">
                    <button 
                        type="button"
                        disabled={disabled}
                        className={disabled ? 'btn--disabled' : ''}
                        onClick={disabled ? null : self.handleDeleteClick}
                    >
                        <svg className="icon icon-file">
                            <use xlinkHref="assets/images/icons/sprite-inline.svg#delete" />
                        </svg>
                    </button>
                </div>
            </div>
        )
    }
}

export class ContactUsFormComponent extends BaseFormComponent {
	constructor(props, ...others) {
        super(props, ...others);
        this.strings = {...this.constructor.defaultProps.strings, ...props.strings};
        AssignProperties(this.strings, props.strings);

        this.state = {
            action: CONTACTUS_ACTION.NONE,
            reCaptchaAPILoaded: false,
            fileDragDetected: false,
            formData: {
                Name: props.name || '',
                Email: props.email || '',
                Message: props.message || '',
                Files: []
            }
        };

        this.fileInput = createRef();
        this.handleAttachFileClick = this.handleAttachFileClick.bind(this);
        this.handleRemoveFileClick = this.handleRemoveFileClick.bind(this);
        this.handleClearFilesClick = this.handleClearFilesClick.bind(this);
        this.handleFileSelected = this.handleFileSelected.bind(this);
        this.handleFilesDrop = this.handleFilesDrop.bind(this);
        this.handleDragEnter = this.handleDragEnter.bind(this);
        this.handleDragLeave = this.handleDragLeave.bind(this);
        this.handleDragOver = this.handleDragOver.bind(this);

        this.addFileToList = this.addFileToList.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.doSubmit = this.doSubmit.bind(this);

        this.getReCaptchaToken = this.getReCaptchaToken.bind(this);
        this.reCaptchaTimer = CreateTimer(200);
        this.checkReCaptchaLoaded = this.checkReCaptchaLoaded.bind(this);

        this._valueHandler.onBlurOptions = {
            'Email': BaseFormComponent.EmailOptions,
            'Name': BaseFormComponent.OPTIONS.AllTrim
        }
    }

    checkReCaptchaLoaded() {
        const self = this;

        self.reCaptchaTimer.stop();

        const grecaptchaApi = window['grecaptcha'];
        if (Boolean(grecaptchaApi) && !self.state.reCaptchaAPILoaded) {
            grecaptchaApi.ready(
                () => {
                    if (self._isMounted) {
                        self.setState({reCaptchaAPILoaded: true});
                    }
                }
            )
        }

        if (!Boolean(grecaptchaApi) && self._isMounted) {
            self.reCaptchaTimer.start();
        }
    }

    componentDidMount() {
        const self = this;
        self._isMounted = true;
        if (Boolean(self.props.isSetFocus)) {
            SetFocusOnFirstFormControl(self, true);
        }

        self.reCaptchaTimer.onTimer = self.checkReCaptchaLoaded;
        self.checkReCaptchaLoaded();
    }

    componentWillUnmount() {
        const self = this;
        self._isMounted = false;
        self.reCaptchaTimer.stop();
    }

    getReCaptchaToken() {
        const self = this;
        const {reCaptchaSiteKey} = self.props;
        if (!Boolean(reCaptchaSiteKey)) {
            return Promise.resolve('');
        }

        const grecaptchaApi = window['grecaptcha'];
        if (!self.state.reCaptchaAPILoaded) {
            return Promise.reject('ReCAPTCHA API was not loaded.');
        }
        else {
            return new Promise((resolve, reject) => {
                try {
                    grecaptchaApi.execute(reCaptchaSiteKey, {action: 'homepage'})
                        .then(token => {
                            resolve(token);
                        });
                }
                catch(error) {
                    //reject(error);
                    reject('ReCAPTCHA API error.');
                }
            })
        }
    }

    handleAttachFileClick() {
        const self = this;

        if (Boolean(self.fileInput.current)) {
            $(self.fileInput.current).trigger('click');
        }
    }

    handleRemoveFileClick(file) {
        const self = this;

        PreventDOMLock(() => {
            if (self._isMounted) {
                const formData = {...self.state.formData};
                formData.Files = formData.Files.filter(p => p != file);
                self.setState({formData: formData});
            }
        });
    }

    handleClearFilesClick() {
        const self = this;

        PreventDOMLock(() => {
            if (self._isMounted) {
                const formData = {...self.state.formData, Files: []};
                self.setState({formData: formData});
            }
        });
    }

    handleFileSelected(event) {
        const self = this;
    
        if (self._isMounted) {
            self.addFileToList(event.target.files[0]);
            event.target.value = null;
        }
    }

    handleDragEnter(event) {
        const self = this;
    
        if (self._isMounted && !self.state.fileDragDetected && event.dataTransfer.types.some(p => p.toLowerCase() == 'files')) 
        {
            event.preventDefault();
            self.setState({fileDragDetected: true});
        }
    }

    handleDragLeave(event) {
        const self = this;
    
        if (self._isMounted && self.state.fileDragDetected) {
            event.preventDefault();
            self.setState({fileDragDetected: false});
        }
    }

    handleDragOver(event) {
        if (event.dataTransfer.types.some(p => p.toLowerCase() == 'files')) {
            event.preventDefault();
        }
    }

    handleFilesDrop(event) {
        const self = this;
        event.preventDefault();

        if (self._isMounted && (event.dataTransfer.files.length > 0)) {
            const file = event.dataTransfer.files[0];

            try {
                const stream = file.stream();
                const reader = stream.getReader();

                reader.read()
                    .then(_ => {
                        self.setState(
                            {fileDragDetected: false},
                            () => self.addFileToList(file)
                        );
                    })
                    .catch(_ => {
                        self.setState({fileDragDetected: false});
                    });
            }
            catch(_) {
                self.setState(
                    {fileDragDetected: false},
                    () => self.addFileToList(file)
                );
            };
        }
    }

    addFileToList(file) {
        const self = this;
        if (self._isMounted && Boolean(file) && (file.size > 0)) {
            const formData = {...self.state.formData};
            formData.Files = formData.Files.slice();
            formData.Files.push(file);
            self.setState({formData: formData});
        }
    }

    handleSubmit(e) {
        const self = this;
        e.preventDefault();

        PreventDOMLock(self.doSubmit);
    }

    doSubmit() {
        const self = this;
        const {formData} = self.state;
        const {verificationToken, contactUsApiUrl} = self.props;

        if (!self._isMounted) {
            return;
        }

        const data = new FormData();
        data.append('Email', formData.Email);
        data.append('Name', formData.Name);
        data.append('Message', formData.Message);

        formData.Files.forEach((f, i) => data.append(`AttachedFiles[${i}]`, f, f.name));

        new Promise(resolve => {
            self.setState({action: CONTACTUS_ACTION.SEND, errors: null}, resolve);
        })
        .then(() => {
            if (self._isMounted) {
                return self.getReCaptchaToken();
            }
        })
        .then(token => {
            if (self._isMounted) {
                if (Boolean(token)) {
                    data.append('ReCaptchaToken', token);
                }

                return MakeApiCall(
                    $.ajax(
                        {
                            method: 'POST',
                            url: contactUsApiUrl,
                            //headers: {RequestVerificationToken: verificationToken, 'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'},
                            headers: {RequestVerificationToken: verificationToken},
                            data: data,
                            processData: false,
                            contentType: false
                        },
                        false,
                        () => !self._isMounted
                    ));
            }
        })
        .then(responseData => {
            if (self._isMounted) {
                const fd = {...formData, Message: '', Files: []};
                DisplaySuccessMessage(responseData.SuccessMessage);
                self.setState({action: CONTACTUS_ACTION.NONE, formData: fd});
            }
        })
        .catch(errors => {
            if (self._isMounted) {
                self.setState({action: CONTACTUS_ACTION.NONE, errors: PrepareError(errors)});
            }
        });
    }

    render() {
        const self = this;
        const strings = self.strings;
        const {maxAttachedSize, reCaptchaSiteKey} = self.props;

        const {formData, errors, action, reCaptchaAPILoaded, fileDragDetected} = self.state;
        const files = formData.Files;
        const totalSize = files.reduce((s, f) => s + f.size, 0);
        const isDisabled = action != CONTACTUS_ACTION.NONE;
        const isFileSizeLimitExceeded = (maxAttachedSize > 0) && (totalSize > maxAttachedSize);
        const isSubminAllowed = (!Boolean(reCaptchaSiteKey) || reCaptchaAPILoaded);

        return (
            <div className="white-panel white-panel--support">
                <ErrorsBlockComponent errors={errors} unstyled={false} excludedErrors="Name Email Message" />
                <form onSubmit={isSubminAllowed ? self.handleSubmit : null}>
                    <div
                        style={{position: 'relative'}}
                        onDragEnter={self.handleDragEnter}
                    >
                        <div className="form-group">
                            <input 
                                type="text" 
                                id="Name"
                                name="Name"
                                placeholder={strings.PH_Name}
                                onChange={self.handleInputChange}
                                onBlur={self.handleInputChange}
                                value={formData.Name || ''} 
                                readOnly={isDisabled} 
                            />
                            <label htmlFor="Name" className="is-icon">
                                <svg className="icon icon-user">
                                    <use xlinkHref="/assets/images/icons/sprite-inline.svg#user" />
                                </svg>
                            </label>
                            <div className="invalid-feedback">{self.getControlError('Name', errors)}</div>
                        </div>
                        <div className="form-group">
                            <input 
                                type="email" 
                                id="Email"
                                name="Email" 
                                placeholder={strings.PH_Email}
                                onChange={self.handleInputChange}
                                onBlur={self.handleInputChange}
                                value={formData.Email || ''} 
                                readOnly={isDisabled} 
                            />
                            <label htmlFor="Email" className="is-icon">
                                <svg className="icon icon-email">
                                    <use xlinkHref="/assets/images/icons/sprite-inline.svg#email"></use>
                                </svg>
                            </label>
                            <div className="invalid-feedback">{self.getControlError('Email', errors)}</div>
                        </div>
                        <div className="form-group">
                            <textarea 
                                id="Message"
                                name="Message" 
                                placeholder={strings.PH_Message}
                                rows={9}
                                onChange={self.handleInputChange}
                                value={formData.Message || ''} 
                                readOnly={isDisabled} 
                            />
                            <label htmlFor="Message" className="is-icon">
                                <svg className="icon icon-message">
                                    <use xlinkHref="/assets/images/icons/sprite-inline.svg#message"></use>
                                </svg>
                            </label>
                            <div className="invalid-feedback">{self.getControlError('Message', errors)}</div>
                        </div>
                        {(maxAttachedSize > 0) && (files.length > 0) &&
                            <div className="form-group">
                                {(files.length > 1) &&
                                    <div>{FormatString(strings.M_AttachedFiles, files.length, HumanFileSize(totalSize))}</div>
                                }
                                {isFileSizeLimitExceeded &&
                                    <div className="invalid-feedback">{FormatString(strings.M_AttachedSizeLimitExceeded, HumanFileSize(maxAttachedSize))}</div>
                                }
                                <div className="attached-files">
                                    <div className="attached-files__items">
                                        {
                                            files.map((file, index) => 
                                                <FileItem key={index} file={file} onDelete={self.handleRemoveFileClick} disabled={isDisabled} />
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                        }
                        <div className="row row--inside support-form__submit">
                            {(maxAttachedSize > 0) &&
                                <div className="col-12 col-sm-6">
                                    <div className="form-group form-group--file">
                                        <input type="file" className="is-hidden" onChange={self.handleFileSelected} ref={self.fileInput} />
                                        {(files.length > 0) &&
                                            <div className="attached-files-buttons">
                                                <button
                                                    type="button"
                                                    className={'btn-add' + (isDisabled ? ' btn--disabled' : '')}
                                                    onClick={self.handleAttachFileClick} 
                                                    disabled={isDisabled}
                                                >
                                                    {strings.BTN_AddFile}
                                                </button>
                                                <button
                                                    type="button"
                                                    className={'btn-clear' + (isDisabled ? ' btn--disabled' : '')}
                                                    onClick={self.handleClearFilesClick} 
                                                    disabled={isDisabled}
                                                >
                                                    {strings.BTN_Clear}
                                                </button>
                                            </div>
                                        }
                                        {(files.length == 0) &&
                                            <button
                                                type="button"
                                                className={'attach-file-btn' + (isDisabled ? ' btn--disabled' : '')}
                                                onClick={self.handleAttachFileClick} 
                                                disabled={isDisabled}
                                            >
                                                <svg className="icon icon-file">
                                                    <use xlinkHref="assets/images/icons/sprite-inline.svg#file" />
                                                </svg>
                                                <span>{strings.BTN_AttachFile}</span>
                                            </button>
                                        }
                                    </div>
                                </div>
                            }
                            <div className="col-12 col-sm-6">
                                <div className="form-group form-group--last">
                                    {isSubminAllowed &&
                                        <button 
                                            type="submit" 
                                            disabled={isDisabled || isFileSizeLimitExceeded}
                                            className={'btn btn--yellow btn--full' + (isDisabled || isFileSizeLimitExceeded ? ' btn--disabled' : '')}
                                        >
                                            {strings.BTN_SendContactUs}<ButtonBusyIndicatorComponent visible={action == CONTACTUS_ACTION.SEND} />
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                        {(fileDragDetected) &&
                            <div 
                                className="file-drop-target"
                                onDragLeave={self.handleDragLeave}
                                onDragOver={self.handleDragOver}
                                onDrop={self.handleFilesDrop}  
                            >
                                Drop file here
                            </div>
                        }
                    </div>
                </form>
            </div>
        );
    }
}
ContactUsFormComponent.propTypes = {
    strings: PropTypes.object,
    verificationToken: PropTypes.string.isRequired,
    contactUsApiUrl: PropTypes.string.isRequired,
    isSetFocus: PropTypes.bool,
    maxAttachedSize: PropTypes.number, //0 - unlim, negative - file attaching not allowed
    reCaptchaSiteKey: PropTypes.string,
}
ContactUsFormComponent.defaultProps = {
    strings: {
        F_Name: 'Name',
        PH_Name: 'Your name',
        F_Email: 'Email',
        PH_Email: 'Email',
        F_Message: 'Message',
        PH_Message: 'Message',
        M_AttachedFiles: 'Attached {0} files ({1})',
        M_AttachedSizeLimitExceeded: 'Limit ({0}) exceeded!',
        BTN_SendContactUs: 'Send message',
        BTN_AddFile: 'Add file',
        BTN_AttachFile: 'Attach file',
        BTN_Clear: 'Clear'
    },
    isSetFocus: false,
    maxAttachedSize: 0
}
